/*global Tier0 dummy  event referer arcotfccurl TYPE REALMOID AWD TARGET GUID known SUBMITSTATUS SMENC SMLOCALE SMAUTHREASON  SMAGENTNAME METHOD arcotClient */
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import LockIcon from 'adp-react-icons/lib/fa/lock';
import UserIcon from 'adp-react-icons/lib/fa/user';
import { Cookies } from 'react-cookie';
import {
  Button,
  Checkbox,
  Textbox,
  Popover,
  OverlayTrigger
} from 'adp-react-components';
import { withRouter, BrowserRouter, Route, Link } from 'react-router-dom';
import CreatePassword from './enroll/create-password.js';
import DeliveryMethod from './enroll/delivery-method.js';
import OtpDevices from './stepup/otp-devices.js';
import {
  loadHttpHeaders,
  loadAjaxBody,
  SessionExpired
} from './../../components/utils/utils.js';
import {checkXSSValidation} from './../../components/utils/CrossSiteValidation.js';

// Quick validation functions
function isValidUsername(username) {
  return username != '';
}

function isValidPassword(value) {
  return value != '';
}
function SignInButton(props) {
  return (
    <Button
      className="primary"
      disabled={!props.isValid}
      onClick={props.onClick}>
      {props.localeVal}
    </Button>
  );
}
function SignInEnrollButton(props) {
  return (
    <Button
      className="primary"
      disabled={!props.isValid}
      onClick={props.onClick}>
      {props.localeVal}
    </Button>
  );
}
const cookies = new Cookies();

let userIdfromCookies = cookies.get('adp_alp_userid');

class LoginForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      isChecked: false,
      rememberMeCheckBox: false,
      orgname: '',
      challenge: '',
      downloadarcotid: '',
      arcotId:'',
      rtnurl: '',
      hdid: '',
      flfailedattempt: '',
      deliverypageexist: false,
      activationcodepageexist: false,
      enrollflow: false,
      wizard: '',
      nextClicked: false,
      isUserValid: false,
      isPasswordValid: false,
      isUserLocked:false,
    };
    this.onSignIn = this.onSignIn.bind(this);
    this.onSignInEnroll = this.onSignInEnroll.bind(this);
    this.onNext = this.onNext.bind(this);
    this.handleKeyPressOnNext = this.handleKeyPressOnNext.bind(this);
    this.handleKeyPressOnSignIn = this.handleKeyPressOnSignIn.bind(this);
  }
  componentWillMount() {
    
    if (userIdfromCookies){
        console.log(' user id from the cookie '+ userIdfromCookies);
        this.setState({
          username: userIdfromCookies,
          rememberMeCheckBox: true,
        });
    }else{
      this.setState({
        rememberMeCheckBox: false,
      });
    }
    var userId = document.getElementById('Change_UserId').value;
    if (userId != '') {
      this.setState({
        username: userId,
        password: '',
      });
    } else {
      if (this.props.username){
        this.onUserNameEntered(this.props.username);
        this.setState({
          username: this.props.username, //change to userId field
          password: '',
        });
      } 
    }

    if (userId != '' ||  userIdfromCookies!='' || this.props.username !=''){
      this.setState({
        isUserValid: true
      });
    }
    try {
      if (Tier0) {
        Tier0.initArcotIDClient();
      }
    } catch (e) {
      // this is only need for local
    }
  }

  onUserNameEntered(value) {
    let userId= value.trim();
    this.props.showErrorMessage('', 'error');
    this.setState({
      username: userId,
      password: '',
      isChecked: false,
      orgname: '',
      challenge: '',
      flfailedattempt: '',
      hdid: '',
      rtnurl: '',
      arcotId:'',
      downloadarcotid: '',
      enrollflow: false,
      deliverypageexist: false,
      activationcodepageexist: false,
      wizard: ''
    });
    if (userId != '') {
      this.props.userLimit(userId);
      this.setState({
        isUserValid: true,
        username: userId
      });
    } else {
      this.setState({
        isUserValid: false
      });

    }
    if (this.state.nextClicked == true) {
      this.props.showUpdateFalse();
    }

    this.props.presentchallenge('');
  }
  onPasswordEntered(value) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      password: value
    });
    if (value != '') {
      this.setState({
        isPasswordValid: true
      });
    }
  }
  forgotPassword() {
    this.props.showErrorMessage('', 'error');
    fetch(context+'/enroll/adpPassword.faces?fypInitialForm=', {
      method: 'POST',
      // same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },

      body:
        'fypInitialForm=fypInitialForm&fypInitialForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        this.setState({
          deliverypageexist: data.fyp.deliverypageexist,
          activationcodepageexist: data.fyp.activationcodepageexist
        });
        //Vinay--based on the deliverypage exist flag, we have to show delivery method or not..please follow enroll flow.
        if (!data.fyp.deliverypageexist) {
          this.props.showAnswerYourQns('0');
          return;
        }
        this.props.showDeliveryMethodFYP();

        this.props.checkDeliveryMethodExists(data.fyp.deliverypageexist);
      });
  }
  handleKeyPressOnNext(e) {
    if (e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.onNext();
    }
  }
  handleKeyPressOnSignIn(e) {
    if (e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      if (this.state.enrollflow) {
        this.onSignInEnroll();
      } else {
        this.onSignIn();
      }
    }
  }
  onChecked(val) {
    this.setState({
      isChecked: val,
      rememberMeCheckBox: val,
    });
    if(!val){
      //remove cookie
      this.removeCookies();
    }
  }
  onSignInEnroll() {
    this.rememberMeUserId();
    this.props.showErrorMessage('', 'error');
    this.props.hideAlerMessageBox();
    this.setState({
      isPasswordValid: false
    });

    {
      /* true if no exception. false if error occurred and we dont need to show the create password*/
    }

    gtag('event', 'Enroll|Click', {
      'event_category': 'Admin Login',
      'event_label': 'UserId'
    });

    this.props.updateShowHide();
    this.props.rememberMe(this.state.isChecked);
    fetch(context+'/enroll/adpPassword.faces?enrollPasswordForm=', {
      method: 'POST',
      // same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },

      body:
        'enrollPasswordForm=enrollPasswordForm&enrollPasswordForm:password=' +
        encodeURIComponent(this.state.password) +
        '&dummy=' +
        dummy +
        '&enrollPasswordForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message, 'error');
          return;
        }
        this.setState({
          deliverypageexist: data.enroll.deliverypageexist,
          activationcodepageexist: data.enroll.activationcodepageexist,
          wizard: data.enroll.wizard
        });
        console.log(
          'data.enroll.deliverypageexist:' + data.enroll.deliverypageexist
        );
        console.log(
          'this.state.deliverypageexist:' + this.state.deliverypageexist
        );
       this.props.checkDeliveryMethodExists(this.state.deliverypageexist);
        if (data.enroll.wizard == 'enroll') this.props.showCreatePassword();
        else if (
          data.enroll.wizard == 'otp' &&
          (data.enroll.deliverypageexist == true ||
            data.enroll.deliverypageexist == 'true')
        )
          this.props.showDeliveryMethod();
        else this.props.showVerificationCode();
      }).catch(error => {
        this.commonErrorMessage(error);
      });
  }

  onSignIn(event) {
    this.rememberMeUserId();
    this.props.showErrorMessage('', 'error');
    this.props.hideAlerMessageBox();
    this.setState({
      isPasswordValid: false
    });
    this.props.updateShowHide();
    this.props.rememberMe(this.state.isChecked);

    var username = checkXSSValidation(this.state.username.toLowerCase()).toUpperCase();
    gtag('event', 'SignIn|Click', {
      'event_category': 'Admin Login',
      'event_label': 'UserId'
    });
    var signedchallenge = '';
    var pin = this.state.password;
    // if (pin == null || pin.length == 0) return false;
    if (pin != '') {
      var chall = this.state.challenge;
      // var flDownloadArcotId =
      // document.getElementById("flDownload").value;
      if (
        this.state.downloadarcotid == true ||
        this.state.downloadarcotid == 'true'
      ) {
        arcotClient.ImportArcotID(this.state.hdid, 'hd');
      }
      signedchallenge = arcotClient.SignChallengeEx(
        chall,
        username,
        'ARCARD',
        pin,
        null
      );
    }

    if ( signedchallenge == null ||(signedchallenge != null && signedchallenge == 'null') ) {
      console.error('signedchallange is null.requesting new browser because of security reason.');
      //just the message says too many tries...here we are telling user to use new browser due to security error.It shouldnt happen normally. but if this condition occurred..
      this.props.showErrorMessage(this.props.signInNewBrowser);
      return;
    }
    console.log('device print before b64', Tier0.get('pm_fp').value);
    fetch(context+'/roaming/presentChallenge.faces', {
          method: 'POST',
          // same-origin is needed to keep the cookies
          credentials: 'same-origin',
          cache:'reload',

          headers: {
            Accept:
              'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body:
            'passwordForm=passwordForm&passwordForm:password=' +
            signedchallenge +
            '&dummy=' +
            dummy +
            '&passwordForm:computerType=&passwordForm:submitButton=&passwordForm:forgotUserIdText=&pm_fp=' +
            btoa(Tier0.get('pm_fp').value) +
            '&passwordForm:forgotUserPasswordText=&flDownload=true&arcotFlashCookie=&returnUrl=' +
            this.state.rtnurl +
            '&javax.faces.ViewState=' +
            Tier0.get('javax.faces.ViewState').value
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data.success == 'false' || data.success == false) {
              if (data.wizard.message == 'true') {
                this.props.showSessionExpired();
                return;
              }
              console.log(" data.wizard.isUserLocked:"+ data.isUserLocked);
              this.setState({
                isUserLocked: data.isUserLocked
              });
              this.props.showErrorMessage(data.wizard.message);
              return;
            } else {
              console.log('data.challengeMode : ' + data.challengeMode);
              if (data.challengeMode == 'HIGH' || data.challengeMode == 'MEDIUM') {
                this.props.stepupOtpDevicesMethod(data.deliveryType);
                if (data.challengeMode == 'HIGH') {
                  this.props.fetchChallengeMode(true);
                }
                if (
                  (data.challengeMode == 'HIGH' &&
                    data.deliveryOtpByEmailOnly == 'true') ||
                  data.deliveryOtpByEmailOnly == true
                ) {
                  console.log(
                    'deliveryOtpByEmailOnly: ' + data.deliveryOtpByEmailOnly
                  );
                  this.props.deliveryOtpByEmailOnly(true, data.deliveryType.mailid);
                  this.props.showChallengeQna(true);
                } else {
                  console.log('show Otp Devices');
                  this.props.showOtpDevices(true);
                }
              } else {
                fetch(context+'/enroll/adpPassword.faces?finalRedirectPage', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: loadHttpHeaders(),
                  body: loadAjaxBody('finalRedirectPage', '')
                })
                  .then(response => {
                    return response.text();
                  })
                  .then(body => {
                    window.location.href = context+'/enroll/redirect.faces';
                  });
              }
            }
          }).catch(error => {
            this.commonErrorMessage(error);
          });

  }


  onHasErrorChange(value) {
    this.setState({
      hasError: value
    });
  }

  onNext(event) {
    gtag('event', 'Next|Click', {
      'event_category': 'Admin Login',
      'event_label': 'UserId'
    });
    //cleaning up arcot ids if anything previously stored.
    cleanUpArcotIds();
    this.props.showErrorMessage('', 'error');
    this.props.hideAlerMessageBox();
    if (document.getElementById('Change_UserId').value) {
      document.getElementById('Change_UserId').value = this.props.username;
    }
    this.setState({
      nextClicked: true,
      isUserValid: false
    });
    this.props.disableSuccessMessage();
    this.props.rememberMe(this.state.isChecked);
    let errorTriggered = false;
    //doing a separate ajax call to check user validity...
    const nextRequest = async () => {
    var resultXSSData = checkXSSValidation(this.state.username);
    var checkUserurl=context+'/ajax?action=adpLoginBean.checkUser';
    const responseCheckUser = await axios({
      method: 'POST',
      url:checkUserurl,
      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data:
        'userEntered=' +
        resultXSSData+
     
        '&type=METHOD_ACTION' ,
       
  
    }).catch(err => {
      this.commonErrorMessage(err);
    });
    if(responseCheckUser && responseCheckUser.data==false){
      this.props.presentchallenge(this.props.invalidUserId);
      return;
    }
    else if(responseCheckUser && responseCheckUser.data=="suspended"){
      this.props.presentchallenge(this.props.userSuspended);
      return;
    }
        //some target url has & .
        var newTarget=TARGET;//new variable needed otherwise if you keep tyring next button on same session, we adding  up encoding targets. it is befause target is Global.
        if(TARGET.indexOf('&')>-1  || TARGET.indexOf('%26')>-1 ){
          newTarget=encodeURIComponent(TARGET);
        }  
        
    const response = await axios({
        method: 'POST',
        url:arcotfccurl,
        withCredentials:'include',
        credentials: 'include',
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        mode: 'cors',
        data:
          'USER=' +
           checkXSSValidation(this.state.username )+
          '&dummy=' +
          dummy +
          '&TYPE=' +
          TYPE +
          '&REALMOID=' +
          REALMOID +
          '&GUID=' +
          GUID +
          '&SMAUTHREASON=' +
          SMAUTHREASON +
          '&METHOD=' +
          METHOD +
          '&SMAGENTNAME=' +
          SMAGENTNAME +
          '&TARGET=' +
          newTarget +
          '&AWD=' +
          AWD +
          '&known=' +
          known +
          '&SUBMITSTATUS=' +
          SUBMITSTATUS +
          '&SMENC=' +
          SMENC +
          '&SMLOCALE=' +
          SMLOCALE
      }).catch(err => {
        //error will be triggered for IE 11 or less always even for a valid user. so we cant put any condition or alert or anthing.
          //no logs needed since browser will automatically log it on the console.
      });

      //this is the weirdest way of tracking error , however the arcot is not sending json so we need to read through response(jsp/html) and find the error key word
      //Unable to create Token
      if (response && response.data.indexOf('Unable to') !== -1) {
        console.log('Unable to create/receive token');
        this.props.presentchallenge(this.props.genericError);
        gtag('event', 'Next|exception', {
          'description': 'Unable to create/Receive Token from arcot server',
          'fatal': false
        });
        throw Error(
          'Unable to create/Receive Token from arcot server.'
        );
        return;
      }
      //	Configuration/Server Error
      if (response && response.data.indexOf('Configuration/Server Error') !== -1) {
        console.log('Configuration/Server Error');
        this.props.presentchallenge(this.props.genericError);
        gtag('event', 'Next|exception', {
          'description': 'Configuration/Server Error. Contact administrator',
          'fatal': false
        });
        throw Error(
          'Configuration/Server Error. Contact administrator'
        );
        return;
      }
      //too many tries
      if (response && response.data.indexOf('Too many tries') !== -1) {
        console.log(this.props.signInNewBrowser);
        this.props.presentchallenge(this.props.signInNewBrowser);
        gtag('event', 'Next|exception', {
          'description': 'Too many tries error message from arcot server. Please close the browser',
          'fatal': false
        });
        throw Error(
          'Too many tries error message from arcot server. Please close the browser'
        );
        return;
      }
      //invalid entry
      if (response && response.data.indexOf('adpLogin.faces') !== -1) {
        console.log('invalid entry');
        this.props.presentchallenge(this.props.invalidUserId);
        gtag('event', 'Next|exception', {
          'description': 'entry is not valid',
          'fatal': false
        });
        throw Error(
          'entry is not valid'
        );
        return;
      }
      // this IE microsoft patch issue. instead of redirecting again to flowmanager it is coming as 
      //post request. So we manually doing a request to flow manager..another HACK..blame IE
      if(response && response.data.indexOf('flowmanager?tokenID') !== -1 && response.data.indexOf('ACTION=\"') !== -1 && response.data.indexOf('\">') !== -1  ){
        const newAjaxUrl=response.data.split("ACTION=\"")[1].split("\">")[0];
        console.log(' calling flowmanager manually due to ms patch ie issue. you only see this call if your shim2 fcc call didnt do a redirect ..');
        let resp= await fetch(newAjaxUrl,{
          method: 'GET',
          headers: {
            Accept:
              'text/html,application/xhtml+xml,application/xml',
              'Content-Type': 'application/x-www-form-urlencoded'
          },
        });
        gtag('event', 'Next|exception', {
          'description': 'ms patch issue but recovering using another ajax call',
          'fatal': false
        });
        console.log('response from second ajaxcall to flowmanager',resp);
      }
      console.log(response);
      console.log('******** ajax call to  presentChallenge..this call should only happen after the flowmanager request....');


      axios({
        method: 'POST',
        url:context+'/enroll/adpPassword.faces?presentChallengeForm=',
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data:
          'presentChallengeForm=presentChallengeForm&presentChallengeForm:submitButton=&javax.faces.ViewState=' +
          Tier0.get('javax.faces.ViewState').value
      })
        .then(resp => {
          if(resp.status==200 ){
          return resp.data;
        }else{
          gtag('event', 'Next|exception', {
            'description': 'Incomplete request',
            'fatal': false
          });
          throw Error(
            'Incomplete request.Please close the browser and start a new session'
          );
        }
        })
        .then(data => {
          this.onNextUpdateState(data);
        })
        .catch(error => {
          this.commonErrorMessage(error);
        });
    };
    nextRequest();
  }
  commonErrorMessage(err){
    this.props.presentchallenge(this.props.signInNewBrowser);
    console.log(err);
  }
  onNextUpdateState(data) {
    if (data.success == 'false' || data.success == false) {
      if(data.presentchallenge){
      if (
        data.presentchallenge.adpOrgOIDNotExists ||
        data.presentchallenge.qnaOrOtpLocked ||
        data.presentchallenge.accountStatusLocked ||
        data.presentchallenge.nonArcotUserMsg  ||
        data.presentchallenge.adpProductsNotExists  ||
        data.presentchallenge.adpSuspendedUser
      ) {
        this.props.presentchallenge(this.props.notAuthorized);
      } else if (data.presentchallenge.aidLocked) {
        this.props.showErrorMessage(this.props.aidLocked);
      } else if (data.presentchallenge.arcotIdOrqnaDisabled) {
        this.props.presentchallenge(this.props.arcotIdOrqnaDisabled);
      } else if (data.presentchallenge.adpDisabledUser) {
        this.props.presentchallenge(this.props.adpDisabledUser);
      } else if (
        data.presentchallenge.emailNotValid  ||
        data.presentchallenge.emailNotExists
      ) {
        this.props.presentchallenge(this.props.invalidEmail);
      }else{
        this.props.presentchallenge(this.props.invalidUserId);
      }
    }else{
      // in this case this happen if user enter crazy value.
        this.props.presentchallenge(this.props.invalidUserId);
    }
    return;

    } else {
      var jsUsername = checkXSSValidation( this.state.username );
      if(data.presentchallenge.username!=jsUsername){
          this.props.presentchallenge(this.props.invalidUserId);
        return;
      }
      console.log("data -- >> ",data);
      this.props.updateShowHide(false);
      //remember UserId if checkbox is enabled. clear cookie if checkbox is not checked.
      this.rememberMeUserId();
      const passwordBox = this.refs.passwordfield;
      if (passwordBox) {
        passwordBox._input.focus();
      }  
     
      this.setState({
        username: checkXSSValidation( this.state.username ),
        password: '',
        orgname: data.presentchallenge.orgname,
        challenge: data.presentchallenge.challenge,
        adpEwallet:data.presentchallenge.adpewallet,
        flfailedattempt: data.presentchallenge.flfailedattempt,
        rtnurl: data.presentchallenge.rtnurl,
        downloadarcotid: data.presentchallenge.downloadarcotid,

        enrollflow:
          data.presentchallenge.enrollflow == 'true' ||
          data.presentchallenge.enrollflow == true
            ? true
            : false
      });
      this.callArcotImport();
    }

  }
  removeCookies(){
   
    console.log('removing cookie  adp_alp_userid since user unselect remember me');
    //cookies.remove('adp_alp_userid',{ domain: '.adp.com', path: '/', secure: true });
    // removing cookies by setting empty one with old date. it works in all the browser we are aware of. cookies.remove having issues with ie11 windows 7.
    cookies.set('adp_alp_userid', '', { domain: '.adp.com', path: '/', secure: true, expires: new Date('December 17, 1970') });
  }
  setCookies(){
  
    console.log('doing remember me by adding cookie adp_alp_userid');
    cookies.set('adp_alp_userid', this.state.username, { domain: '.adp.com', path: '/', secure: true, expires: new Date('December 17, 2029') });
  }
  rememberMeUserId(){
    if(this.state.rememberMeCheckBox){
      this.setCookies();
    }else{
      this.removeCookies();
    }
  }

  callArcotImport() {
    // this will initialize arcot client
    //Tier0.initArcotIDClient();
    var username = checkXSSValidation ( this.state.username );
        fetch(context+'/enroll/adpPassword.faces?presentChallengeFormArcotId=',{
          method: 'POST',
          // same-origin is needed to keep the cookies
          credentials: 'same-origin',
          headers: {
            Accept:
              'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body:
            'presentChallengeFormArcotId=presentChallengeFormArcotId&presentChallengeFormArcotId:submitButton=&javax.faces.ViewState=' +
            Tier0.get('javax.faces.ViewState').value
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.success == 'true' || data.success == true) {
            this.setState({
              hdid: data.arcotId
            });
         }});
  }
  forgotUIDPLinkCall(){
    this.props.forgotUIDPLinkCall();
  }

  render() {
    // Popover for remember my user id
    const popover = (
      <Popover id="popover-1" placement="bottom" title="">
        {this.props.userIdPopoverMsg}
      </Popover>
    );

    // Quick validation done on ever render
    let isValid = isValidUsername(this.state.username);
    let isValidPass = isValidPassword(this.state.password);
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form fyp">
            <div className="form-group user-id">
              <div className="vdl-row">
                <div className="vdl-col-sm-6 vdl-col-xs-12">
                  <label htmlFor="user_id">{this.props.userid}</label>
                </div>
                {/* vdl-col-sm-6 vdl-col-xs-12 */}

                {/*
					 * vdl-col-sm-6 hidden-xs vdl-text-xs-right
					 * vdl-hidden-sm-down
					 */}
              </div>
              {/* vdl-row */}
              <div className="input-group-full">
                <Textbox
                  autoFocus
                  value={this.state.username}                  
                  onChange={this.onUserNameEntered.bind(this)}
                  onKeyPress={this.handleKeyPressOnNext.bind(this)}
                ><UserIcon />
               </Textbox>
              </div>
              {/* input-group-full */}
            </div>
            {/* form-group user-id */}
            {true?(
              <div className="form-group user-remember">
                <Checkbox checked = { this.state.rememberMeCheckBox } onChange={this.onChecked.bind(this)}>
                  {this.props.remember}
                </Checkbox>
                <span className="remember-me-helper">
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    overlay={popover}>
                    <QuestionCircleIcon />
                  </OverlayTrigger>
                </span>
              {/* .remember-me-helper */}
              </div>
            ):null}
            {/* form-group user-remember */}
            {true ? (
              <div className="form-group password" style={this.props.showHide? {display:"block"}:{display:"none"}}>
                <label htmlFor="password">{this.props.passwordLabel}</label>
                <div className="input-group-full">
                  <Textbox
                    value={ this.state.password }                   
                    type="password"
                    ref="passwordfield"
                    onKeyPress={this.handleKeyPressOnSignIn.bind(this)}
                    onChange={this.onPasswordEntered.bind(this)}>
                    <LockIcon />
                  </Textbox>
                </div>
                {/* input-group-full */}
              </div>
            ) : null}
            {/* form-group password */}
            <div className="form-group submit vdl-text-xs-center">
              {this.props.showHide ? (
                <div>
                  {this.state.enrollflow ? (
                    <SignInEnrollButton
                      isValid={this.state.isPasswordValid}
                      localeVal={this.props.signin}
                      onClick={this.onSignInEnroll}
                    />
                  ) : (
                    <SignInButton
                      isValid={this.state.isPasswordValid}
                      localeVal={this.props.signin}
                      onClick={this.onSignIn}
                    />
                  )}
                </div>
              ) : (
                <Button
                  className="primary"
                  //disabled={ !isValid }
                  disabled={!this.state.isUserValid}
                  onClick={this.onNext.bind(this)}>
                  {this.props.next}
                </Button>
              )}
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          <h5 className="vdl-text-xs-center forgot-password">
            {this.props.showHide ?
              (
              <div>{this.state.isUserLocked?(null):(
                <div>{this.state.adpEwallet?
                                          <a onClick={ this.forgotPassword.bind(this)}>
                                          { this.props.forgotPwd }</a>
                                          :<a href="#" onClick={this.forgotUIDPLinkCall.bind(this)}>{this.props.forgotPwd}</a>
                            }</div>)}</div>)
               : (
            /*  <a href={this.props.forgotUIDLink}>{this.props.forgotUid}</a>*/
            <a href="#" onClick={this.forgotUIDPLinkCall.bind(this)}>{this.props.forgotUid}</a>
            )}
          </h5>
          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
      /* vdl-row login-form */
    );
  }
}
LoginForm.propTypes = {
  userid: PropTypes.string,
  admin: PropTypes.string,
  remember: PropTypes.string,
  passwordLabel: PropTypes.string,
  tempPasswordLabel: PropTypes.string,
  signin: PropTypes.string,
  forgot: PropTypes.string,
  forgotUIDLink: PropTypes.string,
  next: PropTypes.string,
  userIdPopoverMsg: PropTypes.string,
  showHide: PropTypes.bool,
  invalidEmail: PropTypes.string,
  adpDisabledUser: PropTypes.string,
  arcotIdOrqnaDisabled: PropTypes.string,
  notAuthorized: PropTypes.string,
  invalidUserId: PropTypes.string,
  signInNewBrowser: PropTypes.string,
  genericError:PropTypes.string,
  userLimit: PropTypes.func,
  presentchallenge: PropTypes.func,
  updateShowHide: PropTypes.func,
  rememberMe: PropTypes.func,
  userSuspended: PropTypes.string
};

LoginForm.getDefaultProps = {
  userid: undefined,
  admin: undefined,
  remember: undefined,
  passwordLabel: undefined,
  signin: undefined,
  forgot: undefined,
  tempPasswordLabel: undefined
};
export default LoginForm;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/login-form.js